/**
 * @file Manages styles for MapAnchor atom.
 * @author kkumari
 */
import { css } from 'styled-components';
export default css(["font-weight:normal;"]);